function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'navy': 'rgb(43, 54, 74)','royal-blue': 'rgb(6, 56, 122)','blue-white': 'rgb(6, 56, 122)','lambs-blood': 'rgb(62, 36, 42)','olive': 'rgb(100, 101, 88)','warm-grey': 'rgb(138, 130, 119)','black-blue': 'rgb(0, 0, 0)','coyote-brown': 'rgb(139, 98, 68)','camel-brown': 'rgb(139, 98, 68)','sapphire': 'rgb(9, 64, 105)','iron': 'rgb(62, 61, 64)','emerald-blue': 'rgb(16, 93, 66)','sand': 'rgb(185, 175, 154)','coyote-brown-blue': 'rgb(112, 80, 27)','storm-blue': 'rgb(86, 106, 149)','clay': 'rgb(153, 96, 63)','natural-blue': 'rgb(185, 175, 154)','brown': 'rgb(119, 82, 64)','orange': 'rgb(250, 114, 74)','kic-blue-royal-blue': 'rgb(6, 56, 122)','white-kic-blue': 'rgb(255, 255, 255)',};

    this.images = {'woodland': 'url("//sanctifiedsupplyco.com/cdn/shop/files/woodland_120x.png?v=7271528692046957873")','arid': 'url("//sanctifiedsupplyco.com/cdn/shop/files/arid_120x.png?v=4381638377376251482")','arid-blue': 'url("//sanctifiedsupplyco.com/cdn/shop/files/arid-midnight-blue_120x.png?v=6821770424152422183")','woodland-blue': 'url("//sanctifiedsupplyco.com/cdn/shop/files/woodland-midnight-blue_120x.png?v=13485892278086917895")','multi-cam': 'url("//sanctifiedsupplyco.com/cdn/shop/files/arid_120x.png?v=4381638377376251482")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
